import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	pause: {
		id: 'custom-sites-extensions.link-cards.autoscroll-wrapper.pause',
		defaultMessage: 'Pause',
		description:
			'Label text for the button that, when clicked, pauses the autoscroll of link cards',
	},
	play: {
		id: 'custom-sites-extensions.link-cards.autoscroll-wrapper.play',
		defaultMessage: 'Play',
		description: 'Label text for the button that, when clicked, plays the autoscroll of link cards',
	},
});
